import { FormPayload } from './ProjectEmployeeForm/interfaces';

const defaultValues: FormPayload = {
  employee: '',
  role: '',
};

export default defaultValues;
